import "./index.css";
import GdnAdTemplate from "../GdnAdTemplate";

/**
 * Google Display Network — 970×250 billboard (rendered @2× = 1940×500).
 * The base layout uses a horizontal logo. The button layout uses the stacked
 * lockup from its Figma frame. The shared body lives in ../GdnAdTemplate.
 */
const BillboardAds = ({id, zoom}) => (
  <GdnAdTemplate id={id} zoom={zoom} variant="horizontal" buttonVariant="stacked" />
);

export default BillboardAds;
